import { CustomerGroupImportRejectedRow } from "@/lib/api";
import { SearchableColumn, SearchableTable } from "./SearchableTable";

const columns: SearchableColumn<CustomerGroupImportRejectedRow>[] = [
  { id: "line", header: "Linha", cell: (row) => row.line, searchValue: (row) => row.line },
  { id: "reason", header: "Motivo", cell: (row) => row.reason, searchValue: (row) => row.reason },
  { id: "raw", header: "Conteúdo", cell: (row) => row.raw, searchValue: (row) => row.raw, className: "font-mono text-xs" },
];

/** Linhas rejeitadas da importação, com pesquisa e paginação (o relatório completo também sai no download). */
export function RejectedRowsTable({ rows }: { rows: CustomerGroupImportRejectedRow[] }) {
  return (
    <SearchableTable
      rows={rows}
      columns={columns}
      rowKey={(row) => `${row.line}-${row.reason}`}
      itemLabel="linhas rejeitadas"
      emptyTitle="Nenhuma linha rejeitada"
      emptyMessage="Todas as linhas do arquivo são válidas."
    />
  );
}
